import { AttributeValueBase } from '@msdyn365-commerce/retail-proxy';
import { ICoreContext } from '@msdyn365-commerce/core';
import React from 'react';
import { IAddress, IPropertyTypeLabels } from './types/order';
import { PropertyType, WithDocumentNamePropertyType } from './propertyTypeEnum';

/* this method is use to show Search criteria used to add the product into the cart */
export default (salesLine: AttributeValueBase[] | undefined, context: ICoreContext, propertyTypeLabels: IPropertyTypeLabels) => {
    // copying line attribute from app config
    const { searchKeyNameAttribute, searchKeyValueAttribute, folioNumberValueAttribute, documentAttribute } = context?.request.app.config;
    const {
        rollNumberLabel,
        lincNumberLabel,
        addressLabel,
        cpidLabel,
        legalDescriptionLabel,
        legalDescriptionCondoLabel,
        titleNumberLabel,
        communityLabel,
        quadrantLabel,
        blockProfileLabel,
        atsLabel,
        folioNumberLabel,
        documentNameLabel,
        municipalAddressLabel
    } = propertyTypeLabels;
    // length 2 is for Roll and LINC number because we are sending address in a line attribute with them so their attribute length will be 2.
    // length 1 is for Address because we are only sending address in a line attribute. So, it's length will be 1.
    if (salesLine) {
        //@ts-ignore
        const linePropertyType = parseInt(salesLine.find(line => line.Name === searchKeyNameAttribute)?.TextValue!);
        //@ts-ignore
        const lineValue = salesLine.find(line => line.Name === searchKeyValueAttribute)?.TextValue!;
        //@ts-ignore
        const folioValue = salesLine.find(line => line.Name === folioNumberValueAttribute)?.TextValue!;
        //@ts-ignore
        const documentAttributeValue: string = salesLine.find(line => line.Name === documentAttribute)?.TextValue || '';
        const documentName = linePropertyType in WithDocumentNamePropertyType ? documentAttributeValue.split('||')[1]?.trim() : undefined;
        switch (linePropertyType) {
            case PropertyType.rollNumber:
                return _renderAddressAndFolio(rollNumberLabel, lineValue, folioNumberLabel, folioValue);

            case PropertyType.lincNumber:
                return _renderAddressAndFolio(lincNumberLabel, lineValue, folioNumberLabel, folioValue);

            case PropertyType.titleNumber:
                return _renderAddressAndFolio(titleNumberLabel, lineValue, folioNumberLabel, folioValue);

            case PropertyType.cpid:
                return _renderAddressAndFolio(cpidLabel, lineValue, folioNumberLabel, folioValue);

            case PropertyType.community:
                return _renderAddressAndFolio(communityLabel, lineValue, folioNumberLabel, folioValue, documentNameLabel, documentName);

            case PropertyType.quadrant:
                return _renderAddressAndFolio(quadrantLabel, lineValue, folioNumberLabel, folioValue, documentNameLabel, documentName);

            case PropertyType.blockProfile:
                return _renderAddressAndFolio(blockProfileLabel, lineValue, folioNumberLabel, folioValue, documentNameLabel, documentName);

            case PropertyType.ats:
                return _renderAddressAndFolio(atsLabel, lineValue, folioNumberLabel, folioValue, documentNameLabel, documentName);
            // below case have same implementations
            case PropertyType.cityWide:
            case PropertyType.none:
                return _renderAddressAndFolio(undefined, undefined, folioNumberLabel, folioValue, documentNameLabel, documentName);

            case PropertyType.address: {
                const addressArr = lineValue.split('||');
                let lineSuite, lineNumber, lineStreetName, lineStreetType, lineQuadrant;
                // check if address length is 5, it means address contain suite. if length is 4 it doesnot have suite
                if (addressArr.length === 5) {
                    [lineSuite, lineNumber, lineStreetName, lineStreetType, lineQuadrant] = lineValue
                        .split('||')
                        .map((val: string) => val?.trim().toLowerCase());
                } else if (addressArr.length === 4) {
                    [lineNumber, lineStreetName, lineStreetType, lineQuadrant] = lineValue
                        .split('||')
                        .map((val: string) => val?.trim().toLowerCase());
                }
                const address: IAddress = {
                    suite: lineSuite,
                    number: lineNumber,
                    streetName: lineStreetName,
                    streetType: lineStreetType,
                    quadrant: lineQuadrant
                };
                const addressToShow = `${address.suite ? address.suite : ''} ${address.number} ${address.streetName} ${
                    address.streetType
                } ${address.quadrant}`.toUpperCase();

                return _renderAddressAndFolio(addressLabel, addressToShow, folioNumberLabel, folioValue);
            }
            case PropertyType.legalDescription: {
                let plan, block, lot;
                [plan, block, lot] = lineValue.split('||').map((val: string) => val?.trim().toLowerCase());
                let docName = '';
                docName = plan;
                // check if block and lot is valid and have some value in it
                if (block && block != '') {
                    docName = `${docName} ${block}`;
                }
                if (lot && lot != '') {
                    docName = `${docName} ${lot}`;
                }
                return _renderAddressAndFolio(legalDescriptionLabel, docName, folioNumberLabel, folioValue);
            }
            case PropertyType.legalDescriptionCondo: {
                const legalDescCondo = lineValue.split('||');
                let plan, unit;
                // check if address length is 2, it means address contain unit. if length is 1 it doesnot have unit
                if (legalDescCondo.length === 2) {
                    [plan, unit] = lineValue.split('||').map((val: string) => val?.trim().toLowerCase());
                } else {
                    [plan] = lineValue.trim().toLowerCase();
                }
                return _renderAddressAndFolio(legalDescriptionCondoLabel, `${plan} ${unit ? unit : ''}`, folioNumberLabel, folioValue);
            }
            default:
                if(folioValue){
                    const folioArr = folioValue?.split('||');
                    return folioArr && folioArr.length > 1
                        ? _renderAddressAndFolio(
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            folioArr[1],
                            municipalAddressLabel
                        )
                        : _renderAddressAndFolio(undefined, undefined, folioNumberLabel, folioArr[0]);
                }
                else{
                    return _renderAddressAndFolio(undefined, undefined, folioNumberLabel, '');
                }
        }
    }

    return;
};
function _renderAddressAndFolio(
    propertyTypeLabel?: string,
    lineValue?: string,
    folioLabel?: string,
    folioValue?: string,
    documentNameLabel?: string,
    documentName?: string,
    municipalAddress?: string,
    municipalAddressLabel?: string
) {
    return (
        <div>
            <div>
                <span>
                    {lineValue && (
                        <span>
                            {propertyTypeLabel}: {lineValue}
                        </span>
                    )}
                </span>
            </div>
            <div>
                <span>
                    {documentName && (
                        <span>
                            {documentNameLabel}: {documentName}
                        </span>
                    )}
                </span>
            </div>
            <div>
                <span>
                    {folioValue && (
                        <span>
                            {folioLabel}: {folioValue}
                        </span>
                    )}
                </span>
            </div>
            <div>
                <span>
                    {municipalAddress && (
                        <span>
                            {municipalAddressLabel}: {municipalAddress}
                        </span>
                    )}
                </span>
            </div>
        </div>
    );
}
